import { ProductBrandCreatePage } from '@/features/product-brand/pages/ProductBrandCreatePage';
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-brand/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_brand.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductBrandCreatePage,
})
